import { logEvent } from 'commons/utils/tracking';
import { MENU_PRIMARY_APPS_CLICK } from 'config/trackingEvents';

export const trackingMenuPrimaryAppsClick = () => {
  logEvent(MENU_PRIMARY_APPS_CLICK, {});
};
